<% var dateFormat = I18n.moment_date_format %>
<% var dateFormatWithYear = I18n.moment_date_format_with_year %>
<% var moreLabel = I18n.more_label %>

<% if (walkInOptions.message) { %>
  <% if (walkInOptions.tooltip) { %>
    <sp-walk-in-message align="center" message="<%= walkInOptions.message %>" tooltip="<%= walkInOptions.tooltip %>"></sp-walk-in-message>
  <% } else { %>
    <sp-walk-in-message align="center" message="<%= walkInOptions.message %>"></sp-walk-in-message>
  <% } %>
<% } %>

<% if (schedulingOptions.type == 'sparkle') { %>
  <div class="section-details-with-icon">
    <div class="section-icons provider-appointment-widget-icon appointment-icon"></div>
    <div class="section-details">
      <div class="section-details--single-date">
      <p><strong><%= I18n.next_label %></strong></p>
      <a class="appointment-booking-link" data-appointment-booking-provider-widget-behaviour="open-appointment-modal"
         data-analytics-element="provider-widget-date" data-analytics-interaction="click" data-analytics-value="<%= moment.parseZone(schedulingOptions.date).format('YYYY-MM-DD') %>">
        <%= Sparkle.Utilities.appointmentDate(moment.parseZone(schedulingOptions.date), AppointmentBooking.config.slot_show_year, dateFormat, dateFormatWithYear) %>
      </a>
      </div>
    </div>
  </div>

  <div class="section-appointments">
    <% _.each(schedulingOptions.slots, function(slot) { %>
      <%= window.Sparkle.Client.jstTemplate('appointment_booking/provider_widget/templates/_appointment_slot')({slot: slot, testIds: testIds, I18n: I18n}) %>
    <% }) %>
    <% if (schedulingOptions.total - schedulingOptions.slots.length > 1) { %>
      <%= window.Sparkle.Client.jstTemplate('appointment_booking/provider_widget/templates/_more_appointments_button')(_.extend({I18n: I18n}, schedulingOptions)) %>
    <% } %>
  </div>

  <sp-provider-appointment-widget-actions class="section-more-appointments-link">
    <sp-button ref="show-more" data-appointment-booking-provider-widget-behaviour="open-appointment-modal" block
               <% if (AppointmentBooking.config.full_schedule_icon) { %>prepend-icon="<%= AppointmentBooking.config.full_schedule_icon %>"<% } %>
               data-analytics-element="provider-widget-full-schedule" data-analytics-interaction="click">
      <%= moreLabel %>
    </sp-button>
  </sp-provider-appointment-widget-actions>
<% } else { %>
  <div class="scheduling-details">
    <% if (schedulingOptions.message) { %><div class="scheduling-details__message"><%= schedulingOptions.message %></div><% } %>

    <% if (schedulingOptions.url) { %>
      <sp-button tag="a" class="scheduling-details__button" color="custom" block href="<%= schedulingOptions.url %>" <% if (schedulingOptions.url.match(/^https?:\/\//)) { %>target="_blank"<% } %>>
        <% if (schedulingOptions.icon) { %>
          <sp-icon name="<%= schedulingOptions.icon %>" size="small" slot="prepend"></sp-icon>
        <% } %>
        <%= schedulingOptions.label %>
      </sp-button>
    <% } %>
  </div>
<% } %>

<% if (walkInOptions.disclaimer) { %>
  <div class="walk-in-disclaimer">
    <%= walkInOptions.disclaimer %>
  </div>
<% } %>

<% if (schedulingOptions.booking_number_message) { %>
  <div class="section-more-information">
    <%= schedulingOptions.booking_number_message %>
  </div>
<% } %>
